var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup411(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.2715,
    y: 2.92261,
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "rotate(134.46 24.2715 2.92261)",
    fill: "#52447D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "matrix(-0.687699 -0.725996 -0.725996 0.687699 24.0918 23.1599)",
    fill: "#52447D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "matrix(0.700409 0.713741 0.713741 -0.700409 0.132812 2.92261)",
    fill: "#52447D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3125,
    y: 23.1599,
    width: 17,
    height: 3,
    rx: 1.5,
    transform: "rotate(-46.5518 0.3125 23.1599)",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup411);
export default __webpack_public_path__ + "static/media/Group 411.20b1b117b71d2e6b40e4ba56719ede73.svg";
export { ForwardRef as ReactComponent };